<div class="breadcrumbs-wrapper">
    <div class="breadcrumbs">
        <h1 [class.margin-bottom]="(breadcrumbs$ | async).length > 1">
            {{ pageTitle | async }}

            <mat-icon class="header-tooltip" *ngIf="headerTooltip | async" [matTooltip]="headerTooltip | async"> info </mat-icon>

            <mat-icon class="deal-header-clipboard" *ngIf="currentDealStatus" matTooltip="Audit Trail" (click)="viewAuditTrail()"> content_paste </mat-icon>
        </h1>

        <ng-container *ngIf="(breadcrumbs$ | async).length > 1">
            <div *ngFor="let breadcrumb of breadcrumbs$ | async; let isLast = last" id="clip" class="crumb">
                <span style="margin-right: -7px" *ngIf="breadcrumb.url && !isLast" [routerLink]="breadcrumb.url">
                    {{ breadcrumb.label }}
                </span>

                <span *ngIf="isLast && (breadcrumbs$ | async).length > 1" class="breadcrumb-last">
                    {{ breadcrumb.label }}
                </span>
            </div>
        </ng-container>
    </div>
    <div class="actions" *ngIf="pageActions$ | async">
        <ng-container [ngTemplateOutlet]="pageActions$ | async"></ng-container>
    </div>
</div>
